<section>

    <sp-modal #modal title="PROCESS IMPORT REQUEST" (confirm)="onSubmit()" confirmButtonText="Process Import Request">
        <p>This action will import all {{ 'components' | terminology | async }}, photos, and other information associated with this data import request.</p>
        <p><i>Note: <strong>This process may take several minutes to complete</strong>. The import of photos is done asynchronously -- it may take some time until all photos are available for viewing.</i></p>
    </sp-modal>

    <div class="row">
        <div class="col-md-8 property">
            {{importRequest.propertyName}}
            <span>{{importRequest.propertyCity}}, {{importRequest.propertyState}}</span>
        </div>
        <div class="col-md-4 date">Requested: {{importRequest?.createdOn | date: 'mediumDate'}}, {{ importRequest?.createdOn | date: 'shortTime'}}</div>
    </div>

    <div class="row stats">
        <div class="col-md-4 stat">
            <strong>{{importRequest.totalPropertyComponents}}</strong>
            <span>Total {{ 'Components' | terminology | async }} Sent</span>
        </div>
        <div class="col-md-4 stat">
            <strong>{{importRequest.includesPropertyComponentIds ? 'Yes' : 'No'}}</strong>
            <span>Includes PropertyComponentId's</span>
        </div>
        <div class="col-md-4 stat">
            <strong>{{importRequest.totalPropertyComponentIds}}</strong>
            <span>Total Matching {{ 'Components' | terminology | async }}</span>
        </div>
    </div>

    <div class="row stats">
        <div class="col-md-3 stat">
            <strong>{{importRequest.totalPropertyComponentsWithGpsData}}</strong>
            <span>{{ 'Components' | terminology | async }} w/ GPS Data</span>
        </div>
        <div class="col-md-3 stat">
            <strong>{{importRequest.totalPropertyComponentsWithPhotos}}</strong>
            <span>{{ 'Components' | terminology | async }} w/ Photos</span>
        </div>
        <div class="col-md-3 stat">
            <strong>{{importRequest.totalPhotos}}</strong>
            <span>Total Photos</span>
        </div>
        <div class="col-md-3 stat">
            <strong>{{importRequest.totalPropertyComponentsNotApplicable}}</strong>
            <span>{{ 'Components' | terminology | async }} Not Applicable</span>
        </div>
    </div>

    <ng-container *ngIf="importRequest?.includesPropertyComponentIds">
        <div class="row steps">
            <div class="col-md-4">
                <ul>
                    <li>
                        <span class="fa-stack fa-3x"><i class="fa fa-circle fa-stack-2x"></i><strong class="fa-stack-1x">1</strong></span>
                        <div>
                            <a [routerLink]="" (click)="onExportDiff()">Download Data Import Request</a>
                            <br />(Compare / Diff)
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-md-4">
                <ul>
                    <li>
                        <span class="fa-stack fa-3x"><i class="fa fa-circle fa-stack-2x"></i><strong class="fa-stack-1x">2</strong></span>
                        <div>Review &amp; edit changes locally</div>
                    </li>
                </ul>
            </div>
            <div class="col-md-4">
                <ul>
                    <li>
                        <span class="fa-stack fa-3x"><i class="fa fa-circle fa-stack-2x"></i><strong class="fa-stack-1x">3</strong></span>
                        <div>
                            <a [routerLink]="" (click)="onImport()">Import the Data Import Request</a>
                            <br />
                            This will complete the Data Import Request process
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </ng-container>

    <ng-container *ngIf="!importRequest?.includesPropertyComponentIds">
        <form [formGroup]="formGroup">
            <ng-container *ngIf="importRequest.statusId !== importRequestStatuses.Processed; else message">
                <div class="row top-buffer-20">
                    <div class="col-md-3 col-sm-4">
                        <div class="form-group">
                            <label for="fiscalYear">Fiscal Year</label>
                            <select class="sp-select form-control" formControlName="fiscalYear" placeholder="Select a Fiscal Year" id="fiscalYear">
                                <option value="">-- Select a Fiscal Year --</option>
                                <option *ngFor="let year of importRequest.fiscalYears" [value]="year.year">{{year.year}} (Start Date {{year.fiscalYearStartMonth}}/1/{{year.year}})</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row top-buffer-20">
                    <div class="col-md-12">
                        <button type="button" class="btn btn-default" [routerLink]="['../']">Cancel</button>
                        <button type="button" class="btn btn-primary" [disabled]="!formGroup?.valid" (click)="modal.show()">Process Import Request</button>
                    </div>
                </div>
            </ng-container>
            <ng-template #message>
                <div class="text-center margin-top-40">

                    <div class="icon-container"><i class="fa fa-thumbs-o-up fa-3x"></i></div>

                    <h3>Import Successful!</h3>
                    <p class="margin-top-25 font-light">
                        All {{ 'components' | terminology | async }}, photos and other information have been imported.
                        <br />
                        <i>The display of all imported photos may take a few minutes until they are available for viewing.</i>
                    </p>
                </div>
            </ng-template>
        </form>
    </ng-container>
</section>
